export default {
  reviewsInRcPay: "RC PAY'деги пикирлер",
  hideStatus:
    "Сиздин соода чекитиңиздин барагынан rcpay.ru сайтында жашыруу керекпи?",
  showStatus:
    "Сиздин соода чекитиңиздин барагында rcpay.ru сайтында көрсөтүү керекпи?",
  review: "Пикир",
  ratings: "Баалар",

  status: {
    all: "Баары",
    publish: "Жарияланган",
    hidden: "Жашырылган",
  },

  hidden: "Жашырылган",
  published: "Жарияланган",

  zeroHide: "Жашырылды",
  zeroPublished: "Жарияланды",

  aboutChapter: {
    title: "Бөлүм тууралуу маалымат",
    descriptions: [
      "«Пикирлер» бөлүмүндө сиздин жайларыңызга келген жана RC PAY аркылуу пикир калтырган бардык кардарлардын пикирлери көрсөтүлөт.",
      "Текстсиз жана 4 же 5 жылдыз баасы менен келген пикирлер автоматтык түрдө жарыяланат. Калган пикирлер демейки боюнча жашырылган болот жана RC PAY'де көрсөтүлбөйт, бирок жалпы рейтингди эсептөөдө эске алынат. Алар көрүнүшү үчүн, кол менен жарыялоо керек.",
    ],
    howPublishOrHide: {
      title: "RC PAY'де пикирлерди кантип жарыялоо же жашыруу керек?",
      list: [
        "Бир же бир нече пикирди тандаңыз.",
        "Төмөнкү иштөө панелинде «Жариялоо» же «Жашыруу» баскычын басыңыз.",
      ],
    },
    howFilter: {
      title: "Пикирлерди кантип фильтрлөө же иреттөө болот?",
      description:
        "Пикирлер менен ыңгайлуу иштөө үчүн фильтрлер жана иреттөө мүмкүнчүлүгү бар:",
      list: [
        "Соода чекиттери боюнча фильтр. Демейки боюнча бардык жайлар боюнча пикирлер көрсөтүлөт. Эгер «Соода чекити» фильтрин тандасаңыз, ошол жайга байланыштуу пикирлер гана көрсөтүлөт.",
        "Дата боюнча фильтр. Датаны тандаганда, ошол мезгилге тиешелүү пикирлер көрсөтүлөт.",
        "Пикирлерди жаңылыгы (биринчилерден жаңы/эски) же баасы боюнча (терс/оң) иреттесе болот.",
      ],
    },
  },

  noReviewsYet: "Азырынча пикирлер жок",
  createShopToGetReviews:
    "RC PAY кардарларынан пикир алуу үчүн соода чекити түзүңүз",
  appearAfterClientSetRating:
    "Бул жерде сиздин жайыңызга келген кардар RC PAY'де баа койгондон кийин пайда болот",
  noPublishedReviews: "Жарияланган пикирлер жок",
  allReviewsHiddenInRc: "Бардык пикирлер RC PAY'де жашырылган",
  allReviews: "Бардык пикирлер",
  allRatings: "Бардык баалар",
  noHiddenReviews: "Жашырылган пикирлер жок",
  allReviewsShownInRc: "Бардык пикирлер RC PAY'де жарыяланган",

  sort: {
    firstNew: "Адегенде жаңылар",
    firstOld: "Адегенде эскилер",
    goodFirst: "Баа боюнча төмөндөө тартибинде",
    badFirst: "Баа боюнча жогорулоо тартибинде",
  },

  removeSelection: "Тандоону алып салуу",
  chooseAllReviews: "Бардык пикирлерди тандоо",
  overallAssessment: {
    title: "Жалпы баа",
    hint: [
      "Фильтрлер коюлганда, жалпы баа жана пикирлердин саны кайра эсептелет.",
      "Жалпы баа бардык пикирлерди, анын ичинде RC PAY'де жашырылган пикирлерди да эске алат.",
    ],
  },
  totalAmountReviews: "Жалпы пикирлер саны",
  amountPublishReviews: "Жарияланган пикирлер саны",
  amountHiddenReviews: "Жашырылган пикирлер саны",
  userPhoto: "Колдонуучунун сүрөтү",
  showInRcPay: "RC PAY'де көрсөтүү",
  hideInRcPay: "RC PAY'де жашыруу",
  hiddenReviewsNotVisibleToRcPayUsers:
    "Жашырылган пикирлер RC PAY колдонуучуларына көрүнбөйт, бирок алар сиздин мекемеңиздин жалпы рейтинги эсептелгенде эске алынат. Алардын көрүнүшүн камсыздоо үчүн бир же бир нече пикирди тандап, төмөнкү панелде «RC PAY'да жарыялоо» баскычын басыңыз.",
};
